<template>
  <div id="data-list-list-view">
    <vs-tabs v-model="tabIndex" class="padTop20">
      <vs-tab
        :label="item.name"
        v-for="(item, index) in vsTabsList"
        :key="index"
      >
        <div class="filterWrap marTop18">
          <div class="flex">
            <template v-if="tabIndex == 0">
              <gc-cmp-vs-input
                v-model="snCode"
                class="filterInput"
                placeholder="请输入SN码"
              />
              <gc-cmp-vs-input
                v-model="filterText"
                class="filterInput marLeft16"
                placeholder="请输入出库单号/订单编号/物流单号"
              />
              <vs-button
                type="filled"
                size="small"
                @click.prevent="getTableData"
                class="marLeft16"
                >查询</vs-button
              >
            </template>
            <template v-else>
              <gc-cmp-vs-input
                v-model="filterText"
                class="filterInput"
                placeholder="请输入SN码查询"
              />
              <vs-button
                type="filled"
                size="small"
                @click.prevent="getErrorTableData"
                class="marLeft16"
                >查询</vs-button
              >
            </template>
          </div>
          <div v-if="filtering('snExpList:snExpExport')||filtering('snSource:snSourceExport')" class="download-wrap marLeft20 pointer" @click.stop="download()">
              <vs-button class="down-btn" type="border" icon-pack="feather" icon="icon-download">下载全部</vs-button>
          </div>
        </div>
        <div v-if="tabIndex == 0 && currGoodsSN != ''" class="currGoodsInfo">
          {{ "【SN码：" + currGoodsSN + "；SN商品：" + currGoodsInfo + "】" }}
        </div>
        <gc-cmp-vs-table :data="tableData" :pager="pager" v-if="tabIndex == 0">
          <template slot="thead">
            <vs-th v-for="(column, index) in columns" :key="index">
              {{ column.name }}
            </vs-th>
          </template>
          <template slot-scope="{ data }">
            <tbody>
              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                <vs-td>{{ tr.time }}</vs-td>
                <vs-td>{{ tr.logType }}</vs-td>
                <vs-td>{{ tr.seller }}</vs-td>
                <vs-td>{{ tr.receiver }}</vs-td>
                <vs-td>{{ tr.outputNo }}</vs-td>
                <vs-td>{{ tr.transitNo }}</vs-td>
              </vs-tr>
            </tbody>
          </template>
        </gc-cmp-vs-table>

        <!-- <gc-cmp-vs-table v-else :data="errorTableData" :pager="false">
          <template slot="thead">
            <vs-th v-for="(column, index) in errorColumns" :key="index">
              {{ column.name }}
            </vs-th>
          </template>
          <template slot-scope="{ data }">
            <tbody>
              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                <vs-td>{{ index }}</vs-td>
                <vs-td>{{ tr.snCode }}</vs-td>
                <vs-td>{{ tr.recordTime }}</vs-td>
                <vs-td>{{ tr.type }}</vs-td>
                <vs-td>{{ tr.nodeName }}</vs-td>
                <vs-td>{{ tr.traceInfo }}</vs-td>
              </vs-tr>
            </tbody>
          </template>
        </gc-cmp-vs-table> -->

          <vs-table :data="errorTableData"  v-else>
            <template slot="thead">
              <vs-th v-for="(column, index) in distColumns" :key="index">
                {{ column.name }}
              </vs-th>
            </template>
            <template slot-scope="{ data }">
              <tbody>
                <vs-tr :data="tr" :key="index" v-for="(tr, index) in data">
                  <vs-td>{{ index + 1 }}</vs-td>
                  <vs-td>{{ tr.snCode }}</vs-td>
                  <vs-td>{{ tr.recordTime }}</vs-td>
                  <vs-td>{{ tr.type }}</vs-td>
                  <vs-td>{{ tr.nodeName }}</vs-td>
                  <vs-td>{{ tr.customerName}}</vs-td>
                  <vs-td>{{ tr.traceInfo }}</vs-td>
                </vs-tr>
              </tbody>
            </template>
          </vs-table>
          <!-- <gc-vs-pagination
            :total="pagerD.totalCount"
            v-model="pagerD.pageNo"
            :max-items="pagerD.pageSize"
             v-if="tabIndex !== 0"
          ></gc-vs-pagination> -->
          <gc-vs-pagination
            v-if="tabIndex !== 0"
            :pager="pagerD"
            pageNoName='pagerNo'
            pageSizeName="pageSize"
            totalName="totalCount"
            @handleSizeChange="handleSizeChange"
            @handleCurrentChange="handleCurrentChange"
            ></gc-vs-pagination>

      </vs-tab>
    </vs-tabs>
  </div>
</template>

<script>
import GcCmpVsTable from "@/group-cloud/components/vsTable";
import GcCmpVsInput from "@/group-cloud/components/vsInput";
import { CommodityQueryApi } from "@/modules/server-api/commodity-sys/query";
import { downloadExcel } from '@/utils/downloadExcel.js';
export default {
  data() {
    return {
      tabIndex: 0,
      snCode: "",
      filterText: "",
      baseUrl: "data-dist/api/dist/goods", //请求链接
      currGoodsSN: "", //当前商品SN
      currGoodsInfo: "", //当前商品信息
      vsTabsList: [
        {
          label: "origin",
          name: "SN码溯源查询",
        },
        {
          label: "error",
          name: "SN码异常查询",
        },
      ],
      errorColumns: [
        {
          name: "序号",
        },
        {
          name: "SN码",
        },
        {
          name: "录入时间",
        },
        {
          name: "异常类型",
        },
        {
          name: "所属客户",
        },
        {
          name: "追踪信息",
        },
      ],
      errorTableData: [],
      columns: [
        {
          name: "时间",
        },
        {
          name: "日志类型",
        },
        {
          name: "出货方",
        },
        {
          name: "收货方",
        },
        {
          name: "出库单号/订单编号",
        },
        {
          name: "物流单号",
        },
      ],
       distColumns: [
        {
          name: "序号",
        },
        {
          name: "SN码",
        },
        {
          name: "录入时间",
        },
        {
          name: "异常类型",
        },
        {
          name: "所属门店",
        },
        {
          name: "所属客户",
        },
        {
          name: "追踪信息",
        }
      ],
      tableData: [],
      pager: {
        page: 1,
        size: 20,
        total: 0
      },
      pagerD: {
        pageNo: 1,
        pageSize: 20,
        totalCount: 0,
      }

    };
  },
  mounted() {},
  methods: {
    //SN码溯源查询
    async getTableData() {
      this.$vs.loading();
      let resp = await CommodityQueryApi.getSnSourceList({
        code: this.snCode,
        suggest: this.filterText,
      });
      if (resp.code < 0) {
          this.$notifyError(resp.error)
      }
      if (resp.code < 0) {
          this.$notifyError(resp.error)
      }
      if(resp.result != null) {
        this.$vs.loading.close();
        resp = resp.result;
        this.tableData = resp.snRecords;
        this.currGoodsInfo = resp.snGoodsName || "";
        this.currGoodsSN = resp.snCode || "";
      } else {
        this.$vs.loading.close();
        this.tableData = [];
        this.currGoodsInfo = "";
        this.currGoodsSN = "";

      }
    },
    //SN异常查询
    async getErrorTableData() {
      // let resp = await CommodityQueryApi.getSnExceptionList({
      //         code:
      // });
      let resp = await CommodityQueryApi.getSnExceptionList({
        pageNo:this.pagerD.pageNo,
        pageSize:this.pagerD.pageSize,
        data: {
          code: this.filterText,
        },
      });

      this.errorTableData = resp.result.list ||[];
      // this.pagerD.totalCount = Math.ceil(resp.result.totalCount / 20)
      //this.pagerD.totalCount = resp.result.totalPageCount
      this.pagerD.totalCount = resp.result.totalCount

    },
    async download() {
      //组装下载参数
      let url = '';
      let param = {};
      if(this.tabIndex == 0 && this.filtering('snSource:snSourceExport')){//溯源查询
        url = '/data-dist/api/dist/goods/snSourceExport';
        param = {
          code: this.snCode,
          suggest: this.filterText
        }
      }else{//异常
        url = '/data-dist/api/dist/goods/snExpExport';
        param = {
         code: this.filterText,
        }
      }
      let fileName = this.vsTabsList[this.tabIndex].name + '.xlsx';
      downloadExcel(url, param, fileName);
    },
    //更改每页条数
    handleSizeChange(val){
      this.pagerD.pageSize = val;
      this.getErrorTableData();
    },
    handleCurrentChange(val){
      this.pagerD.pageNo = val;
      this.getErrorTableData();
    }
  },
  components: {
    GcCmpVsTable,
    GcCmpVsInput,
  },
  watch: {
    tabIndex(index) {
      this.filterText = "";
      this.snCode = "";
      this.currGoodsSN = "";
      this.currGoodsInfo = "";
      this.tableData = [];
      this.errorTableData = [];
      if(index == 0){ //普通单品
        // 这里切换到SN溯源查询的时候不需要默认调用，如果需要改的话再这里加一下就好
      }
      else{//组合单品
        this.getErrorTableData();
      }
    },
   "pager.pageNo"() {
      this.getTableData();
    }
    // ,
    // "pagerD.pageNo"() {
    //   this.getErrorTableData();
    // }
  },
};
</script>

<style lang="scss" scoped>
@import "../commodity.scss";
.currGoodsInfo {
  color: #4090ff;
  font-size: 14px;
  height: 30px;
  line-height: 30px;
}
</style>
